import { types as coreTypes } from '@sitebuilder/core';
import { EnvSync } from '../types';

export interface IEnvDiffApiClient {
    getDiff(
        src: string,
        dest: string,
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<coreTypes.Theme>;
}

export class EnvDiffApiClient implements IEnvDiffApiClient {
    baseUrl: string;
    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    private getHeaders(
        h: {
            [key: string]: string;
        },
        options?: { accessToken?: string }
    ) {
        const headers: {
            [key: string]: string;
        } = {};

        if (typeof options?.accessToken === 'string' && options.accessToken.length > 0) {
            headers.Authorization = `bearer ${options.accessToken}`;
        }

        return { ...headers, ...h };
    }

    async getDiff(
        src: string = 'stg',
        dest: string = 'dev',
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${this.baseUrl || ''}/api/admin/environments/compare?src=${src}&dest=${dest}`;

        const res = await fetch(url, {
            method: 'GET',
            headers: this.getHeaders({}, options),
        });

        const items = await res.json();
        return items;
    }

    async merge(
        src: string = 'stg',
        dest: string = 'dev',
        data: EnvSync[],
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${this.baseUrl || ''}/api/admin/environments/sync?src=${src}&dest=${dest}`;

        const res = await fetch(url, {
            method: 'POST',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify({
                items: data,
            }),
        });

        const items = await res.json();
        return items;
    }

    async list(options?: { originalHostname?: string; accessToken?: string }) {
        const url = `${this.baseUrl || ''}/api/admin/environments/`;

        const res = await fetch(url, {
            method: 'GET',
            headers: this.getHeaders({}, options),
        });

        const items = await res.json();
        return items;
    }
}
